// @ts-nocheck
import { useState, useMemo } from "react";
import {
  Box,
  VStack,
  Text,
  Divider,
} from "@chakra-ui/react";
import { Drawer } from "barte-design-system";
import { formatCurrency, showToast, getPaymentErrorMessages } from "@/utils";
import { PixListItem } from "@/services/Api/pixN8nService";
import { getBankNameByIspb } from "./receipt-boleto/format";
import { usePayment } from "@/hooks/usePayment";
interface CancelPaymentDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  payment: PixListItem | null;
  onAfterCancel?: () => void;
}

const CancelPaymentDrawer = ({ isOpen, onClose, payment, onAfterCancel }: CancelPaymentDrawerProps) => {
  const [isCancelling, setIsCancelling] = useState(false);
  const { cancelPayment } = usePayment();
  const summaryText = useMemo(() => {
    if (!payment) return "";
    const amountText = formatCurrency({ value: payment.amount || 0 });
    const recipient = payment.recipientName || "—";
    const bankName = getBankNameByIspb(payment.credit_bank_ispb) || "—";
    return (
      <>
        {" Você estava transferindo "}
        <strong>{amountText}</strong>
        {" para "}
        <strong>{recipient}</strong>
        {" em "}
        <strong>{bankName}</strong>
      </>
    );
  }, [payment]);

  const handleConfirmCancel = async () => {
    if (!payment) return;
    if (!payment.transferId) {
      showToast({ message: "ID do pagamento não encontrado", type: "error" });
      return;
    }
    try {
      setIsCancelling(true);
      await cancelPayment(payment.transferId);
      onClose();
      if (onAfterCancel) onAfterCancel();
    } catch (error: any) {
      const errorMessages = getPaymentErrorMessages(error);
      errorMessages.forEach((errorMapping) => {
        showToast({
          type: "error",
          message: errorMapping.message,
          title: errorMapping.title,
        });
      });
    } finally {
      setIsCancelling(false);
    }
  };

  return (
    <Drawer
      title="Cancelar agendamento"
      isOpen={isOpen}
      onClose={onClose}
      footer={{
        secondaryButton: { children: "Voltar", variant: "outline", onClick: onClose },
        primaryButton: {
          children: "Cancelar agendamento",
          className: "!bg-[#C68A31] hover:!bg-[#C68A31] !text-white",
          loading: isCancelling,
          onClick: handleConfirmCancel,
        },
      }}
    >
      <VStack spacing={6} align="stretch" flex="1">
        <Box px={0} mb={10} p={6}>
          <VStack spacing={2} align="stretch" mt={250} p={0}>
            <Text fontSize="20px" fontWeight="600" color="gray.900" p={0} mt={0}>
              Tem certeza que deseja cancelar esse agendamento?
            </Text>
            <Text fontSize="16px" color="gray.500" pb={6} mt={2}>Essa operação não poderá ser desfeita</Text>
          </VStack>
          <Divider my={6} p={0} mt={0} />
          <Text fontSize="16px" color="gray.700" p={0} mt={0}>{summaryText}</Text>
        </Box>
      </VStack>
    </Drawer>
  );
};

export default CancelPaymentDrawer;


